import { render } from "./Pmpay.vue?vue&type=template&id=fde83a40&scoped=true"
import script from "./Pmpay.vue?vue&type=script&lang=js"
export * from "./Pmpay.vue?vue&type=script&lang=js"

import "./Pmpay.vue?vue&type=style&index=0&id=fde83a40&scoped=true&lang=css"

import exportComponent from "E:\\work\\copy\\work\\fa\\tgkw\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fde83a40"]])

export default __exports__